import './index.css';
import { MenuProvider } from "../../context/MenuContext";
import { MenuNav } from '../../components/MenuNav/MenuNav';
import { Menu } from '../../components/Menu/Menu';
import { SingleProductProvider } from '../../context/SingleProductContext';
import { CartProvider } from '../../context/CartContext';
import { Provider as BusProvider } from 'react-bus';
import { Cart } from '../../components/Cart/Cart';
import { DynamicHtmlComponent } from '../../components/DynamicHtmlComponent/DynamicHtmlComponent';
import { OrderOnlineState } from '../../components/OrderOnlineState/OrderOnlineState';

export const IndexWrapper = () => {
    return (
        <BusProvider>
            <MenuProvider>
                <SingleProductProvider>
                    <CartProvider>
                        <Index />
                        <Cart />
                    </CartProvider>
                </SingleProductProvider>
            </MenuProvider>
        </BusProvider>
    );
}

const Index = () => {
    return (
        <>
            <DynamicHtmlComponent html={document.settings.header.html} css={document.settings.header.css} />
            <DynamicHtmlComponent html={document.settings.custom_before_html_order_online.html} css={document.settings.custom_before_html_order_online.css} />
            <div className="order_online_app">
                <OrderOnlineState />
                <MenuNav />
                <Menu />
            </div>
            <DynamicHtmlComponent html={document.settings.custom_after_html_order_online.html} css={document.settings.custom_after_html_order_online.css} />
            <DynamicHtmlComponent html={document.settings.footer.html} css={document.settings.footer.css} />
        </>
    );
}